<template>
  <div>
    <Default
      v-if="layoutName === 'default'"
      ref="componentDefault"
      class="layout-default" />
    <Blank
      v-else-if="layoutName === 'blank'"
      class="layout-blank" />
    <ModalEndTime
      v-model="isShowModalEndTime"
      :data-end-time="dataEndTime"
      @close="close($event)" />
    <audio
      id="audio"
      style="display:none;"
      src="/images/music.mp3"
    />
  </div>
</template>

<script>
// import io from 'socket.io-client'
import Default from '@/layouts/default.vue'
import Blank from '@/layouts/blank.vue'
import { initialSocket } from '@/plugins/Socket'
import io from 'socket.io-client'
import ModalEndTime from './components/ModalEndTime.vue'

export default {
  name: 'App',
  components: {
    Default,
    Blank,
    ModalEndTime
  },
  data () {
    return {
      isShowModalEndTime: false,
      socket: null,
      socketNotification: null,
      dataEndTime: {},
      isReRenderNavbar: true
    }
  },
  computed: {
    layoutName () {
      const layoutName = this.$route?.meta?.layout?.toLowerCase() || 'default'
      return layoutName
    },
    branchData () {
      return this.$store.getters['Branch/branch']
    },
    userData () {
      return this.$store.getters['User/user']
    }

  },
  mounted () {
    this.setupSocket()
  },
  methods: {
    play () {
      document.getElementById('audio').play()
    },
    close (val) {
      this.isShowModalEndTime = val
    },
    setupSocket () {
      const socket = initialSocket('notification', 'praivech-socket')
      socket.on('connect', () => {
        // console.log('%c --> Socket Connected ', 'color: #bada55')
      })
      socket.on('disconnect', () => {
        // console.log('%c --> Socket disconnected', 'color; #red')
      })
      const socket2 = io(`${process.env.VUE_APP_API_URL}`)
      socket2.on(`${this.branchData.clinicId}/${this.branchData.branchId}/${this.userData.userId}/endTime`, (data) => {
        this.dataEndTime = data
        this.isShowModalEndTime = true
        this.play()
      })
      socket.on(`${this.branchData.clinicId}/${this.branchData.branchId}/${this.userData.userId}/notification`, () => {
        // console.log('data', data)
        const child = this.$refs.componentDefault
        child.triggerChild()
        // console.log('socket-notification-appsss')
      })
    }
  }
}
</script>

<style scoped>

</style>
